import { useEffect } from 'react'
import { pushMeta } from './headManager.js'

/**
 * Set this page's <head>: usePageMeta({ title, description, canonical,
 * noindex, image, jsonLd }). Fields left out keep the route defaults
 * (site description, logo image, canonical = this path). Pass null to
 * register nothing (e.g. while the data is loading).
 */
export default function usePageMeta(meta, priority = 1) {
  const key = meta ? JSON.stringify(meta) : ''
  useEffect(() => {
    if (!key) return undefined
    return pushMeta(JSON.parse(key), priority)
  }, [key, priority])
}
